import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { IncidentAbandonedVehicle } from '../models/incident-abandoned-vehicle.model';
import { Observable } from 'rxjs';

@Injectable()
export class AbvFeeService extends IncidentServiceBase<IncidentAbandonedVehicle> {
    constructor() {
        super('AbvFee', () => new IncidentAbandonedVehicle());
    }

    public getIncidentByProhibitionId = (prohibitionId: number): Observable<IncidentAbandonedVehicle> => this.get(`incident/abvfee/prohibition/${prohibitionId}`);
}
